import type { MeResponse } from "@esi/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";
import { ok } from "./api-errors.ts";

/**
 * The signed-in user's own scope (`GET /api/me`): names for the account menu and the effective
 * residency for home. Fields an older API revision lacks come back undefined (canary window).
 */
export type Me = Partial<MeResponse> & Pick<MeResponse, "userId">;

/** `enabled: false` where the viewer may not be a member (an operator under a support grant). */
export function useMe(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["me"] as const,
    queryFn: async (): Promise<Me> => ok(await api.api.me.$get()),
    staleTime: 5 * 60 * 1000,
    enabled: options.enabled ?? true,
  });
}
